import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/auth';
import {supabase} from '../supabaseClient';


export const useCheckActivityCompleted = (activity) => {
  const { user } = useAuth();
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    const checkActivityCompleted = async () => {
      if (user && activity) {
        const { data, error } = await supabase
          .from('user_activities')
          .select('*')
          .eq('user_id', user.id)
          .eq('activity_id', activity.id)
          .limit(1);

        if (error) {
          console.error('Error checking activity status:', error);
          return;
        }

        const completed = data.length > 0;

        setIsCompleted(completed);
      }
    };

    checkActivityCompleted();
  }, []);

  return isCompleted;
};

export const completeActivity = async (user, activity) => {
  try {
      if (user && activity) {
          // Marcar la actividad como completada en la base de datos de Supabase
          const { error } = await supabase
              .from('user_activities')
              .insert([{ user_id: user.id, activity_id: activity.id }]);
          
          if (error) {
              throw new Error(error.message);
          }

          // Obtener el puntaje actual del usuario desde la base de datos
          const { data: userData, error: userError } = await supabase
              .from('users')
              .select('score')
              .eq('id', user.id)
              .single();

          if (userError) {
              throw new Error(userError.message);
          }

          const currentScore = parseInt(userData.score);
          const newScore = currentScore + parseInt(activity.score);

          // Actualizar el campo "score" del usuario en la base de datos de Supabase
          const { data, error: updateError } = await supabase
              .from('users')
              .update({ score: newScore })
              .eq('id', user.id);
          
          if (updateError) {
              throw new Error(updateError.message);
          }

          console.log(`Se asignaron ${activity.score} puntos al usuario con ID ${user.id}. El puntaje total ahora es ${newScore}.`);
      }

  } catch (error) {
      console.log(error)
  }
};
